import { Alert, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';

/** Info banner when selected rows include values on holiday columns (source week); those days are skipped on copy. */
export function CopyRowsHolidayBanner() {
  const { colors } = useTheme();

  return (
    <Alert
      severity='info'
      icon={false}
      sx={{
        borderRadius: 0,
        py: 1.25,
        px: 2,
        bgcolor: alpha(colors.surfaceAccent.default, 0.12),
        color: colors.text.main,
        border: 'none',
        borderBottom: `1px solid ${alpha(colors.surfaceAccent.default, 0.25)}`,
        '& .MuiAlert-message': {
          padding: 0,
          width: '100%',
          fontSize: 14,
          fontWeight: 500,
          lineHeight: 1.4,
        },
      }}
    >
      Selected rows have a holiday, holidays won&apos;t be copied.
    </Alert>
  );
}
